<template>
  <div class="detail" style="font-size: 18px;">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card card1">
          <div slot="header" class="clearfix">
            <span>Table of Compound General Info</span>
          </div>
          <div v-for="(o, index) in infoList" :key="index" class="text-item">
            <span class="name">{{ o["name"] }}</span>
            <span class="val">{{ o["val"] }}</span>
          </div>
        </el-card>
      </el-col>
      
    </el-row>
    <el-row :gutter="24">
      <!-- <el-col :span="16">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>able of Anti-inflammation Bioactivity</span>
          </div>
          <div v-for="(o, index) in Tar_List" :key="index" class="text-item">
            <span class="name">{{ o["name"] }}</span>
            <span class="val">{{ o["val"] }}</span>
          </div>
        </el-card>
      </el-col> -->
      <el-col :span="10">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Picture of Structure</span>
          </div>
          <el-image
            style="width: 250px; height: 250px"
            :src="info.info.Structure"
            fit="fill"
          ></el-image>
          <div class="btn-warp">
            <el-button type="primary" @click="downloadFile">Download</el-button>
          </div>
        </el-card>
      </el-col>
      <el-col :span="14">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Table of Compound Physical and Chemical Properties</span>
          </div>
          <!-- <div class="text-item">
            (Molecular Weight, Chemical Formula, logP, # HB acc, # HB don, #
            RotB )
          </div> -->
          <div v-for="(o, index) in exList" :key="index" class="text-item">
            <span class="name">{{ o["name"] }}</span>
            <span class="val1">{{ o["val"] }}</span>
          </div>
          <div class="btn-warp">
            <el-button type="primary" @click="downloadFile1">Download</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "detail",
  data() {
    return {
      downUrl: "",
      activeName: ["1", "2", "3", "4"],
      info: {
        info: {},
        exInfo: {},
      },     
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    exList() {
      let arr = [];
      for (let i in this.info.exInfo) {
        if (i !== "Structure") {
          arr.push({
            name: i,
            val: this.info.exInfo[i] || "--",
          });
        }
      }
      return arr;
    },
    infoList() {
      let arr = [];
      for (let i in this.info.info) {
        if (i !== "Structure" && i !== "id") {
          arr.push({
            name: i,
            val: this.info.info[i] || "--",
          });
        }
      }
      return arr;
    },
    // Tar_List() {
    //   let arr = [];
    //   for (let i in this.info.tarInfo) {
    //     if (i !== "Structure") {
    //       arr.push({
    //         name: i,
    //         val: this.info.tarInfo[i] || "--",
    //       });
    //     }
    //   }
    //   return arr;
    // },
  },
  methods: {
    download() {
      let downUrl = "/api/saveStructure?id=" + this.$route.query.id;
      const { origin } = window.location;
      window.open(`${origin}${downUrl}`);
    },
    async downloadFile(){
      const URL = "/api/saveStructure?id=" + this.$route.query.id;
      const res = await this.$http.get(URL);
      const blob = new Blob([res.data], {type: res.headers['content-type']});
      let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
      let result = patt.exec(res.headers['content-disposition']);
      let filename = "result.sdf";

      const downloadElement = document.createElement('a');
      const href = window.URL.createObjectURL(blob);

      console.log(filename);
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.download = filename ; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
},
    async downloadFile1(){
      const URL = "/api/saveToCsv?id=" + this.$route.query.id;
      const res = await this.$http.get(URL);
      const blob = new Blob([res.data], {type: res.headers['content-type']});
      let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
      let result = patt.exec(res.headers['content-disposition']);
      let filename = "result.csv";

      const downloadElement = document.createElement('a');
      const href = window.URL.createObjectURL(blob);

      console.log(filename);
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.download = filename ; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
},
    downloadCsv() {
      let downUrl = "/api/saveToCsv?id=" + this.$route.query.id;
      const { origin } = window.location;
      window.open(`${origin}${downUrl}`);
    },
  },
  mounted() {
    this.$http({
      url: "/api/rdkit/queryInfoById",
      params: {
        id: this.$route.query.id,
      },
    }).then((res) => {
      this.info = res.data.data;
    });
  },
};
</script>
<style scoped>
  .content {
    margin-bottom: 20px;
  }
  .text-item {
    display: flex;
    margin-bottom: 5px;
    /* justify-content: space-between; */
  }
  .name {
    font-weight: bold;
    margin-right: 80px;
    width: 130px;
    /* text-align: right; */
  }
  .val {
    word-break: break-all;
    flex: 1;
    text-align: left;;
    /* display: block; */
    /* padding-left: 150px; */
  }
   .val1 {
    word-break: break-all;
    flex: 1;
    text-align: right;;
    /* display: block; */
    /* padding-left: 150px; */
  }
  .box-card {
    height: 400px;
    margin-bottom: 10px;
  }
  .card1{
    overflow-y: scroll !important;
  }
  .btn-warp {
    display: flex;
    justify-content: flex-end;
  }
  .detail {
    padding:0 100px;
    margin: 0 auto;
  }
</style>